import { observable, decorate, action, runInAction } from 'mobx';
import Auth from '../modules/auth/Auth';

class Tags {
    tags = [];

    getTagsByType = async (type) => {
        if (!type || (this.tasks && this.tasks.length)) return;
        let [tRes, tErr] = await Auth.superAuthFetch(`/api/Tags/getTagsByType?type=${type}`, null, true);
        if (tErr || !tRes || !tRes.length) { console.log("tErr", tErr); return; }

        runInAction("update values after fetching data", () => {
            this.tags = tRes;
        });
    }
}

decorate(Tags, {
    tags: observable,
    getTagsByType: action
});

export default new Tags;
